import * as App from '../constants/App';

const initialState = {
  currentUser: null,
  afterUserCreate: false,
  signOuted: false,
  signInCheckLoading: false,
  signInChekLoaded: false,
  signInCheckResult: false,
  firstLoaded: false,
  jsLoaded: false,
  infoMsg: null,
  infoMsgType: null,
  nowLoading: false,
  unreadNotificationCount: null,
  notifications: {
    notifications: [],
    page: 1,
    total_page: 1,
    count: 0
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case App.USER_APP_SIGN_OUT:

      return Object.assign({}, state, {
        signOuted: true,
        signInCheckLoading: false,
        signInCheckResult: false,
        afterUserCreate: false,
        currentUser: null,
        infoMsg: 'ログアウトしました',
        infoMsgType: 'success',
        unreadNotificationCount: null,
        notifications: {
          notifications: [],
          page: 1,
          total_page: 1,
          count: 0
        }
      });
    
    case App.USER_SIGN_OUT_RESET:
      return Object.assign({}, state, {
        signOuted: false
      })

    case App.LOAD_START:
      return Object.assign({}, state, {
        nowLoading: true
      });
    case App.LOAD_END:
      return Object.assign({}, state, {
        nowLoading: false
      });
    case App.USER_SIGN_IN_CHECK:
      return state;
    case App.HEADER_JS_SETED:
      return Object.assign({}, state, {
        jsLoaded: true,
      });
    case App.USER_SIGN_IN_CHECK_REQUEST:
      return Object.assign({}, state, {
        signInCheckLoading: true,
        signInChekLoaded: false,
        signInCheckResult: false
      });
    case App.USER_SIGN_IN_CHECK_RESULT:
      let rlt, user, afterCreate;

      if (action.result.status === 200 && action.result.data.user && localStorage.getItem('token')) {
        rlt = true
        user = action.result.data.user
        if (!user.registered_at) {
          afterCreate = true
        } else {
          afterCreate = false
        }
      } else {
        rlt = false
        user = null
        afterCreate = false
      }

      return Object.assign({}, state, {
        signInCheckLoading: false,
        signInChekLoaded: true,
        signInCheckResult: rlt,
        firstLoaded: true,
        currentUser: user,
        afterUserCreate: afterCreate
      });

    case App.NOTICE_ADD:
      return Object.assign({}, state, {
        infoMsg: action.infoMsg,
        infoMsgType: action.infoMsgType,
      });
    case App.NOTICE_REMOVE:
      return Object.assign({}, state, {
        infoMsg: null,
        infoMsgType: null,
      });
    case App.NOTIFICATION_UNREAD_GET_RESULT:
      return Object.assign({}, state, {
        unreadNotificationCount: action.unreadCount
      })
    case App.NOTIFICATION_GET_RESULT:
      
      const newNotifications = action.notificationGetResult.notifications
      const mergeNotifications = state.notifications.notifications.concat(newNotifications)
      return Object.assign({}, state, {
        notifications: {
          ...action.notificationGetResult,
          notifications: mergeNotifications
        }
      })
    case App.NOTIFICATION_GET_RESET:
      return Object.assign({}, state, {
        notifications: {
          notifications: [],
          page: 1,
          total_page: 1,
          count: 0
        }
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/App.js